import toastr from 'toastr'
window.toastr = toastr

export function showToast(type, message) {
  toastr[type](message)
}
